// Shared status/source badge helpers used across the Orders page family.
import React from 'react';
import { Badge } from '@/components/ui/badge';

export const STATUS_COLORS = {
  created: 'bg-gray-100 text-gray-700',
  stock_allocated: 'bg-emerald-100 text-emerald-800',
  pending_procurement: 'bg-red-100 text-red-700 border border-red-200',
  ready_for_pick: 'bg-emerald-100 text-emerald-800',
  picked: 'bg-blue-100 text-blue-800',
  qa_pending: 'bg-purple-100 text-purple-800',
  qa_completed: 'bg-teal-100 text-teal-800',
  qa_rejected: 'bg-red-100 text-red-700',
  invoiced: 'bg-green-100 text-green-800',
  partially_invoiced: 'bg-yellow-100 text-yellow-800',
  cancelled: 'bg-red-100 text-red-700',
  expired: 'bg-orange-100 text-orange-700 border border-orange-200',
};

export const STATUS_LABELS = {
  pending_procurement: 'PENDING TO PROCUREMENT',
  ready_for_pick: 'READY TO PICK',
  picked: 'PICKED',
  cancelled: 'CANCELLED',
  expired: 'AUTO-EXPIRED',
};

export const CANCELLABLE_STATUSES = new Set([
  'created', 'stock_allocated', 'pending_procurement', 'ready_for_pick',
  'picked', 'qa_pending', 'qa_completed',
]);

export function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || String(status || '').replace(/_/g, ' ').toUpperCase();
  return (
    <Badge className={STATUS_COLORS[status] || 'bg-gray-100 text-gray-700'}>
      {label}
    </Badge>
  );
}

export function SourceBadge({ source }) {
  const meta = {
    store_portal:   { label: 'Store Portal',   cls: 'bg-orange-50 text-orange-700 border-orange-200' },
    og_retailer_app:{ label: 'OG Retailer App',cls: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
    bulk_upload:    { label: 'Bulk Upload',    cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  };
  const m = meta[source] || meta.bulk_upload;
  return (
    <span
      className={`text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded border ${m.cls}`}
      data-testid={`order-source-${source || 'bulk_upload'}`}
    >
      {m.label}
    </span>
  );
}
